import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React from 'react';

import { UserRoleDto } from '@/api/generated';
import { useMaintenanceStatus } from '@/components/maintenance/useMaintenanceStatus.util.ts';
import { themeColors } from '@/config/theme/themeColors.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { useAppNavigation } from '@/utils/useAppNavigation.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import {
  ADMINISTRATION_TAB_PARAM,
  AdministrationTab,
} from '@/views/administration/model/AdministrationTab.model.ts';
import { readTimeLabel } from '@/views/chats/utils/chatReadReceipts.util.ts';

export const MaintenanceModeNotice: React.FC = () => {
  const { t } = useTranslationWithPrefix('views.util.maintenance.notice');
  const { role } = useUserContext();
  const { push } = useAppNavigation();
  const status = useMaintenanceStatus();

  if (!status?.active || !status.canWork || !status.endDate) {
    return null;
  }

  return (
    <Paper
      data-maintenance-notice
      elevation={0}
      role="status"
      sx={{
        alignItems: 'center',
        background: themeColors.greyDarker,
        borderRadius: 5,
        bottom: 16,
        boxShadow: '0 8px 24px rgba(17, 17, 17, 0.2)',
        color: themeColors.white,
        display: 'flex',
        gap: 1,
        left: '50%',
        maxWidth: 'calc(100vw - 32px)',
        pl: 1.5,
        position: 'fixed',
        pr: role === UserRoleDto.Admin ? 0.5 : 2,
        py: 0.5,
        transform: 'translateX(-50%)',
        zIndex: theme => theme.zIndex.appBar + 1,
      }}
    >
      <BuildCircleOutlinedIcon sx={{ color: themeColors.accentColor, fontSize: 20 }} />
      <Typography sx={{ color: 'inherit' }} variant="f12Medium">
        {t('text', { date: readTimeLabel(status.endDate) })}
      </Typography>
      {role === UserRoleDto.Admin && (
        <Button
          onClick={() =>
            push({
              params: { [ADMINISTRATION_TAB_PARAM]: AdministrationTab.MAINTENANCE },
              pathname: RouteEnum.ADMINISTRATION,
            })
          }
          size="small"
          sx={{ color: themeColors.accentColor, fontWeight: 600 }}
          variant="text"
        >
          {t('manage')}
        </Button>
      )}
    </Paper>
  );
};
